import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {
  Card, Col, Row, List, Button
} from 'antd'
import {CircleChartAssets} from "../CircleChart";
import {setAssetType, setAdvancedSearchEnabled} from "../../../actions/AppAction";
import {getStorageHistory, getFolderSpace, getAssetsList} from "../../../actions/StorageAction";
import {getFolderSpaceRepresentation} from "../../../utils/StorageUtils";

export class TrashAssets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spaceMonth: []
    }
  }

  componentDidMount() {
    const {
      workclient,
      intl
    } = this.props;
    this.props.getFolderSpace(workclient);
    this.props.getAssetsList(workclient, intl);
    this.props.getStorageHistory(workclient);
  }

  handleOnClickShowHide = (assetType) => {
    this.props.setAssetType(assetType);
    this.props.setAdvancedSearchEnabled(true);
  };

  render() {
    // const {intl, newColor, onDelete, loadingClearAllTrash, isAdminOrSuperadmin = false} = this.props;
    const {contractedSpace, intl, newColor, folderSpaceInBytes, assetsList, totalAssets, onDelete, loadingClearAllTrash, isAdminOrSuperadmin = false} = this.props;
    const sizeMoment = (folderSpaceInBytes / Math.pow(2,30)).toFixed(2);
    const folderSpace = getFolderSpaceRepresentation(folderSpaceInBytes);

    return (
      <React.Fragment>
        <Card id="assets-card" hoverable style = {{
            borderColor: "#40a9ff",
            borderRadius: "10px",
            paddingBottom: "22px",
        }}>
          <Row gutter={25} style={{display: 'flex'}}>
            <Col lg={8} md={12} xs={24} span={8} >
              <div style={{height: "150px", width: "150px", display: "block", margin: "40px auto"}}>
                <CircleChartAssets assetList={assetsList}
                  folderSpaceInBytes={folderSpaceInBytes}
                  contractedSpaceInGb={contractedSpace}/>
              </div>
              <p style={{color: '#8E8E8E', fontWeight: 400, fontSize: 15, textAlign: "center" }}>{folderSpace === 0 ? "0 GB" : folderSpace} / {contractedSpace} GB</p>
              <Card style={{ minHeight: '0px', paddingTop: '20px'}} hidden={parseFloat(sizeMoment) < parseFloat(Math.floor(contractedSpace).toFixed(2)) || isNaN(parseFloat(sizeMoment)) ? true: false}>
                <h5 style={{color: 'red'}}><b>{intl.formatMessage({id: "trash-assets-full"})}</b></h5>
              </Card>
            </Col>
            <Col lg={8} md={12} xs={24} span={8}>
              <List
                style={{borderRadius: '10px', marginBottom: '10px', border: '1px solid #efefef', }}
                header={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                  <Row>
                    <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'total_assets'})}</b></Col>
                    <Col span={8} style={{textAlign: "right"}}><b>{totalAssets}</b></Col>
                  </Row>
                </div>}
                footer={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                  <Row>
                    <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'stored_weight'})}</b></Col>
                    <Col span={8} style={{textAlign: "right"}}><b>{folderSpace}</b></Col>
                  </Row>
                </div>}
                bordered
                dataSource={assetsList}
                renderItem={(item) => (
                  <List.Item style={{padding: "3px 0px", borderBottom: 0}}
                             onClick={() => this.handleOnClickShowHide(item.type)}>
                    <div className="container">
                      <Row>
                        <Col  span={16} style={{textAlign: "left"}}><span
                          style={{background: item.background}} className="circle"/>{item.title}</Col>
                        <Col span={8} style={{textAlign: "right"}}>{item.qty}</Col>
                      </Row>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
            <Col lg={8} md={24} xs={24} span={8}>
              <div style={{ height: '100%', display: 'flex', alignContent: 'center', flexWrap: 'wrap'}}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{intl.formatMessage({id: "trash-assets-advice"})}</div>
                {isAdminOrSuperadmin && <Button
                    style={{ backgroundColor: newColor, borderColor: newColor, width: 140 }}
                    type="primary"
                    onClick={onDelete}
                    loading={loadingClearAllTrash}
                  >
                    {intl.formatMessage({id: "trash-assets-delete-all"})}
                </Button>}
              </div>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  storageHistory: state.storage.history,
  folderSpace: state.storage.folderSpace,
  assetsList: state.trash.trashUsageList,
  totalAssets: state.trash.totalAssets,
  loadingClearAllTrash: state.trash.loadingClearAllTrash
});

const mapDispatchToProps = {
  setAssetType,
  setAdvancedSearchEnabled,
  getStorageHistory,
  getFolderSpace,
  getAssetsList
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrashAssets)))
